import React, { useMemo, memo, useCallback } from 'react';
import './CameraControls.css';
import Button from '../../primitives/Button/Button';

import { ReactComponent as UpIcon } from '../../../../assets/icon/caret-expand-less.svg';
import { ReactComponent as DownIcon } from '../../../../assets/icon/caret-expand-more.svg';
import { ReactComponent as LeftIcon } from '../../../../assets/icon/caret-chevron-left.svg';
import { ReactComponent as RightIcon } from '../../../../assets/icon/caret-chevron-right.svg';
import { useCameraControls, CameraControlsContextValue } from '../../context/CameraControlsCallbackContext';
// import { useCameraControls, CameraControlsContextValue } from '../context/CameraControlsContext';

interface CameraControlsProps {
}

const CameraControlButton: React.FC<{className: string, icon: React.ReactNode, onClick: (val: boolean) => void}> = memo(({ className, icon, onClick })  => {
  const handlePointerDown = useCallback(() => {
    onClick(true);
  }, [onClick]);

  const handlePointerUp = useCallback(() => {
    onClick(false);
  }, [onClick]);

  return (
    <div className={className + " hud-button" }>
      <Button onPointerDown={handlePointerDown} onPointerUp={handlePointerUp} icon={icon} />
    </div>
  );
});

const HUDCameraControls: React.FC<CameraControlsProps> = memo(({ }) => {
  const { moveForward, moveBackward, turnLeft, turnRight } = useCameraControls() as CameraControlsContextValue;

  const cameraControlButtons = useMemo(() => (
    <>
      <CameraControlButton className="hud up-button" icon={<UpIcon />} onClick={moveForward} />
      <CameraControlButton className="hud down-button" icon={<DownIcon />} onClick={moveBackward} />
      <CameraControlButton className="hud left-button" icon={<LeftIcon />} onClick={turnLeft} />
      <CameraControlButton className="hud right-button" icon={<RightIcon />} onClick={turnRight} />
    </>
  ), [moveForward, moveBackward, turnLeft, turnRight]);

  return (
    <>
      { cameraControlButtons }
    </>
  );
});

export default HUDCameraControls;
